export default import.meta.ROLLDOWN_FILE_URL_4bzLQN83kEjQjEZhq2gUow